var defaultTransformOrder = [
    'x',
    'y',
    'z',
    'scale',
    'scaleX',
    'scaleY',
    'scaleZ',
    'rotate',
    'rotateX',
    'rotateY',
    'rotateZ',
    'skewX',
    'skewY',
    'skewZ',
    'perspective'
];
var aliasMap = {
    x: 'translateX',
    y: 'translateY',
    z: 'translateZ'
};
export var getStylesFromPoser = function (poser) {
    var values = poser.get();
    var hasTransform = false;
    var styles = Object.keys(values).reduce(function (acc, key) {
        if (defaultTransformOrder.indexOf(key) === -1) {
            acc[key] = values[key];
        }
        else {
            hasTransform = true;
        }
        return acc;
    }, {});
    if (hasTransform) {
        styles.transform = defaultTransformOrder.reduce(function (acc, key) {
            var _a;
            if (values[key]) {
                acc.push((_a = {}, _a[aliasMap[key] || key] = values[key], _a));
            }
            return acc;
        }, []);
    }
    return styles;
};
//# sourceMappingURL=utils.js.map